import { defineMessages } from 'react-intl'

export default defineMessages({
  cancel: {
    id: 'containers.ProjectPage.components.ProjectDetails.buttons.cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'containers.ProjectPage.components.ProjectDetails.buttons.save',
    defaultMessage: 'Get free quote',
  },
  saveChanges: {
    id: 'containers.ProjectPage.components.ProjectDetails.buttons.saveChanges',
    defaultMessage: 'Save changes',
  },
  saving: {
    id: 'containers.ProjectPage.components.ProjectDetails.buttons.saving',
    defaultMessage: 'Saving',
  },
  productType: {
    id: 'containers.ProjectPage.components.ProjectDetails.form.productType',
    defaultMessage: 'Project category',
  },
  subscribeToNewsletter: {
    id: 'containers.ProjectPage.components.ProjectDetails.subscribeToNewsletter',
    defaultMessage: 'Yes - send me artist recommendations and tips',
  },
})
